import { AdjustmentsHorizontalIcon, EyeIcon, Squares2X2Icon } from '@heroicons/react/24/outline';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { editorUiAtom, type RightPanelTab } from '../../../store/atoms/editorUiAtom';
import { PanelTab } from '../../atoms/PanelTab';
import { LayersTab } from '../LayersTab';
import { PreviewTab } from '../PreviewTab';
import { PropertiesTab } from '../PropertiesTab';

export function RightPanel() {
  const { t } = useTranslation('slideEditor');
  const [uiState, setUiState] = useAtom(editorUiAtom);

  const setTab = (tab: RightPanelTab) => {
    setUiState(prev => ({ ...prev, rightPanelTab: tab }));
  };

  const tabs: {
    key: RightPanelTab;
    label: string;
    icon: React.ComponentType<{ className?: string | undefined }>;
  }[] = [
    { key: 'preview', label: t('rightPanel.tabs.preview'), icon: EyeIcon },
    { key: 'properties', label: t('rightPanel.tabs.properties'), icon: AdjustmentsHorizontalIcon },
    { key: 'layers', label: t('rightPanel.tabs.layers'), icon: Squares2X2Icon },
  ];

  return (
    <div className="flex flex-col h-full">
      {/* Tabs header */}
      <div className="flex border-b-hairline border-ctx-layout-border shrink-0">
        {tabs.map(tab => (
          <PanelTab
            key={tab.key}
            label={tab.label}
            icon={tab.icon}
            isActive={uiState.rightPanelTab === tab.key}
            onClick={() => setTab(tab.key)}
          />
        ))}
      </div>

      {/* Tab content */}
      <div className="flex-1 overflow-y-auto">
        {uiState.rightPanelTab === 'preview' && <PreviewTab />}
        {uiState.rightPanelTab === 'properties' && <PropertiesTab />}
        {uiState.rightPanelTab === 'layers' && <LayersTab />}
      </div>
    </div>
  );
}
